const userLicenseInfo = {
    INSTITUTIONAL: 'Institutional',
    BUSINESS: 'Business',
    PROFESSIONAL: 'Professional',
    FREE: 'Free',
};

export default userLicenseInfo;
